import { render } from "./Stores.vue?vue&type=template&id=c8a2b48a&scoped=true"
import script from "./Stores.vue?vue&type=script&lang=js"
export * from "./Stores.vue?vue&type=script&lang=js"

import "./Stores.vue?vue&type=style&index=0&id=c8a2b48a&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a2b48a"]])

export default __exports__